import React from 'react';
import ReactDOM from 'react-dom';
import Page from "../BaseComponents/Page/Page";
import {FaRegularIcon, FaSolidIcon} from "../FontAwesomeIcons";
import PropTypes from "prop-types";

export default class IframeModal extends React.Component {

    constructor(props) {
        super(props);
        this.style = {
            height:"100%",
            width:"100%",
            overflow:'auto',
            border:0
        }
    }

    componentDidMount() {
        document.body.classList.add('noscroll');
    }

    componentWillUnmount() {
        document.body.classList.remove('noscroll');
    }

    render() {
        return (
            <Page
                title={this.props.title}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                onLeftIconClick={this.props.onDismiss}
                active={true}
                noPadding={true}
                content={
                    <iframe src={this.props.src} style={this.style}> </iframe>
                }
            />
        );
    }

}


IframeModal.propTypes = {
    src: PropTypes.string,
    title: PropTypes.string,
    onDismiss: PropTypes.func,
}
